import axios from 'axios';
import { unset } from 'lodash';
import { ThunkAction } from 'redux-thunk';
import { CommonRootState } from '../combineReducers';
import {
  IContactInformationStatus,
  IHiringClientsStatus,
  IOperatingDetailsStatus,
  IOrganizationProfileStatus
} from '../interfaces/organizationProfileNotifications';

export const updateOrganizationProfileNotifications = (
  organizationId: string
): ThunkAction<Promise<IOrganizationProfileStatus>, CommonRootState, null, Actions> => dispatch => {
  return new Promise<IOrganizationProfileStatus>(async (resolve, reject) => {
    try {
      const excludeKeys = ['contactInformationSection.branchLocationsIsCompleted'];
      const { data } = await axios.get<IOrganizationProfileStatus>(
        `/api/v3.1/organizations/${organizationId}/pageStatus`
      );
      excludeKeys.forEach(path => {
        unset(data, path);
      });
      dispatch(changeOrganizationProfileNotifications(data));
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export const updateOrganizationProfileContactInformationNotifications = (
  organizationId: string
): ThunkAction<Promise<IContactInformationStatus>, CommonRootState, null, Actions> => dispatch => {
  return new Promise<IContactInformationStatus>(async (resolve, reject) => {
    try {
      const excludeKeys = ['branchLocationsIsCompleted'];
      const { data } = await axios.get<IContactInformationStatus>(
        `/api/v3.1/organizations/${organizationId}/pageStatus/contactInformation`
      );
      excludeKeys.forEach(path => {
        unset(data, path);
      });
      dispatch(
        changeOrganizationProfileNotifications({
          contactInformationSection: data
        })
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export const updateOrganizationProfileOperationDetailsNotifications = (
  organizationId: string
): ThunkAction<Promise<IOperatingDetailsStatus>, CommonRootState, null, Actions> => dispatch => {
  return new Promise<IOperatingDetailsStatus>(async (resolve, reject) => {
    try {
      const { data } = await axios.get<IOperatingDetailsStatus>(
        `/api/v3.1/organizations/${organizationId}/pageStatus/operationDetails`
      );
      dispatch(
        changeOrganizationProfileNotifications({
          operationDetailsSection: data
        })
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export const updateOrganizationProfileHiringClientsNotifications = (
  organizationId: string
): ThunkAction<Promise<IHiringClientsStatus>, CommonRootState, null, Actions> => dispatch => {
  return new Promise<IHiringClientsStatus>(async (resolve, reject) => {
    try {
      const { data } = await axios.get<IHiringClientsStatus>(
        `/api/v3.1/organizations/${organizationId}/pageStatus/hiringClients`
      );
      dispatch(
        changeOrganizationProfileNotifications({
          hiringClientSection: data
        })
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export const changeOrganizationProfileNotifications = (payload: Partial<IOrganizationProfileStatus>) =>
  ({
    type: 'CHANGE_ORGANIZATION_PROFILE_NOTIFICATIONS',
    payload
  } as const);

export type Actions = ReturnType<typeof changeOrganizationProfileNotifications>;
